<nz-row [nzJustify]="'center'">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <article nz-typography>
      <h1 i18n="@@page-about-project-content-title" nz-typography>
        Explore Instagram profiles anonymously with Ig4u
      </h1>
      <p
        [nzType]="'secondary'"
        i18n="@@page-about-project-content-paragraph-0"
        nz-typography>
        The service is in no way associated with Instagram.
      </p>
      <p i18n="@@page-about-project-content-paragraph-1" nz-typography>
        Welcome to the ultimate platform for anonymously browsing Instagram
        profiles for free. Our service is designed to provide you with seamless
        access to profile information, stories, highlights, photos and reels,
        all while respecting the rights of content creators.
      </p>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-about-project-content-key-features-section-title"
        nz-typography>
        Key Features
      </h2>
      <ul>
        <li>
          <p
            i18n="@@page-about-project-content-key-features-section-paragraph-0"
            nz-typography>
            <strong>Anonymous Browsing:</strong> doesn't require any info from
            you other than profile username.
          </p>
        </li>
        <li>
          <p
            i18n="@@page-about-project-content-key-features-section-paragraph-1"
            nz-typography>
            <strong>Free Access:</strong> enjoy all features of Ig4u for free.
          </p>
        </li>
        <li>
          <p
            i18n="@@page-about-project-content-key-features-section-paragraph-2"
            nz-typography>
            <strong>Comprehensive Content:</strong> view profile info, stories,
            highlights, photos, and videos seamlessly.
          </p>
        </li>
        <li>
          <p
            i18n="@@page-about-project-content-key-features-section-paragraph-3"
            nz-typography>
            <strong>Content Download:</strong> download content for personal
            use, respecting the rights of content creators.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-about-project-content-respect-for-content-ownership-section-title"
        nz-typography>
        Respect for Content Ownership
      </h2>
      <p
        i18n="
          @@page-about-project-content-respect-for-content-ownership-section-paragraph-0"
        nz-typography>
        We value and uphold the rights of content creators. All content viewed
        or downloaded through Ig4u belongs to its respective creator, and we
        encourage users to use downloaded content responsibly and with respect
        for intellectual property rights.
      </p>
    </article>
  </nz-col>
</nz-row>
